<template>
    <el-drawer
        title="置顶演出排序"
        :visible="visible"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @open="show"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
            >
            <el-form-item prop="city" label="城市:">
                <el-row :gutter="10">
                    <el-col :span="20">
                        <city-select :value.sync="formData.city"></city-select>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    </el-col>
                </el-row>
                <small class="MT10">如需查看全国置顶的演出，请填写【全国】</small>
            </el-form-item>
            </el-form>
            <el-table                
				:data="tableData"
                style="width: 100%"
                size="small"
                stripe
                border
                v-loading="dataLoading"
                row-key="id"
                class="sortable MT20"
				v-if="tableData && tableData.length > 0 "
            >
			 
              <el-table-column prop="sort" label="序号"></el-table-column>
                <el-table-column prop="activityId" label="ID"></el-table-column>
                <el-table-column prop="title" label="名称" min-width="150" show-overflow-tooltip></el-table-column>
				<el-table-column label="置顶设置" min-width="220" prop="isTop">
					<template slot-scope="scope" v-if="tableData[scope.$index].show">						
						<el-radio-group v-model="tableData[scope.$index].isTop" size="medium">
							<el-radio :label="1" class="MT10">在本地演出之前展示</el-radio>
							<el-radio :label="0" class="MT10">在本地演出之后展示</el-radio>
						</el-radio-group>
					</template>
				</el-table-column>		
				
            </el-table>
			
            <div v-if="tableData" class="MT10"><small><i class="el-icon-info"></i> 按住鼠标可拖动排。待审核、已结束等非常规状态的演出不会展示出来</small></div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import Sortable from "sortablejs";
import CitySelect from '@/components/CitySelect';

export default {
    components: {
        CitySelect
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            dataLoading: false,
            btnLoading:false,
            tableData:[],
            formData: {
                city: ''
            },
            sortForm: [],
            rules: {
                city: [{ required: true, message: "请选择城市" }],
            }
        }
    },
	computed:{
		
	},
    methods:{
        close() {
            this.$emit('update:visible', false);
        },
        show() {
            this.formData.city = '';
            this.tableData = [];
        },
        async search(){
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.dataLoading = true;
                    const response = await this.$request({
                        url: '/activityTop/listByCity',
                        params: this.formData
                    })
                    const {msg, state, result} = response.data;
                    this.dataLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.tableData = result || [];
					this.tableData.map(item => {
						item.show = item.cityId == 0 ? 1 : 0
					})
					
                    this.$nextTick(() => { 
                        this.drag(); 
                        this.updateSort();
                    }); 
                }
            });
            
        },
        drag(){
            const el = document.querySelectorAll('.sortable> .el-table__body-wrapper > table > tbody')[0];
            Sortable.create(el, {
                disabled: false, // 拖拽不可用? false 启用
                ghostClass: 'sortable-ghost', //拖拽样式
                animation: 150, // 拖拽延时，效果更好看
                onEnd: (e) => { // 拖拽结束时的触发
                    let arr = this.tableData; // 获取表数据
                    arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                    this.$nextTick(() => {
                        this.tableData = arr;
                        this.updateSort();
                    })
                },
            });
        },
        updateSort(){
            this.sortForm = []
			console.log(this.tableData)
			
            this.tableData.map((item,index) => {
                this.sortForm.push({
                    id: item.id,
                    sort: index + 1,
					isTop:item.isTop
                })
            })
        },
        async submitForm(){
			this.sortForm = []			
			this.tableData.map((item,index) => {
			    this.sortForm.push({
			        id: item.id,
			        sort: index + 1,
					isTop:item.isTop
			    })
			})
            this.btnLoading = true;
            const response = await this.$request({
                method: 'post',
                url: '/activityTop/sort',
                data: this.sortForm
            });
            const {msg, state} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.$emit('update:visible', false);
        }
    }
}
</script>